import { render, staticRenderFns } from "./Chat.vue?vue&type=template&id=002bd542&scoped=true"
import script from "./Chat.vue?vue&type=script&lang=js"
export * from "./Chat.vue?vue&type=script&lang=js"
import style0 from "../../assets/styles/chat.css?vue&type=style&index=0&id=002bd542&prod&lang=css&scoped=true&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "002bd542",
  null
  
)

export default component.exports